import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
// Replace these with your Firebase project details
const firebaseConfig = {
  apiKey: "AIzaSyBehrf1b_TAuA0vuAeHjSyH9Z8n-yTecxI",
  authDomain: "monkeytimemcp.firebaseapp.com",
  projectId: "monkeytimemcp",
  storageBucket: "monkeytimemcp.firebasestorage.app",
  messagingSenderId: "294473843910",
  appId: "1:294473843910:web:2325eea2b4e181c5e5c3c7",
  measurementId: "G-CYZGX69ERC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
